// Home Page — Fortune Teller Listings (Firestore-backed)
import { renderHeader, renderBottomNav } from '../components/header.js';
import { navigate } from '../router.js';
import { isFirebaseReady } from '../firebase.js';
import { getAllFortuneTellers } from '../services/db.js';
import { demoFortuneTellers } from '../data/demo-store.js';
import { t } from '../i18n.js';

export async function renderHome() {
  const app = document.getElementById('app');

  // Show loading
  app.innerHTML = `
    ${renderHeader()}
    <div class="page">
      <div style="text-align:center; margin-bottom: var(--space-xl);">
        <h1 style="font-size: var(--font-3xl); margin-bottom: var(--space-xs);">🔮</h1>
        <h2 class="page-title" style="margin-bottom: var(--space-xs);">${t('home_title')}</h2>
        <p class="page-subtitle" style="margin-bottom:0;">${t('home_subtitle')}</p>
      </div>
      <div style="text-align:center; padding: var(--space-xl);">
        <div class="loading-spinner"></div>
      </div>
    </div>
    ${renderBottomNav('home')}
  `;

  // Load from Firestore or demo
  let tellers = isFirebaseReady() ? await getAllFortuneTellers() : demoFortuneTellers;
  // Fallback if db is empty
  if (tellers.length === 0) {
      tellers = demoFortuneTellers;
  }
  tellers = tellers.filter(ft => ft.available !== false);

  app.innerHTML = `
    ${renderHeader()}
    <div class="page">
      <div style="text-align:center; margin-bottom: var(--space-xl);">
        <h1 style="font-size: var(--font-3xl); margin-bottom: var(--space-xs);">🔮</h1>
        <h2 class="page-title" style="margin-bottom: var(--space-xs);">${t('home_title')}</h2>
        <p class="page-subtitle" style="margin-bottom:0;">${t('home_subtitle')}</p>
      </div>

      <div class="fortune-teller-list">
        ${tellers.length > 0 ? tellers.map(ft => renderTellerCard(ft)).join('') : `
          <div class="empty-state">
            <div class="empty-state-icon">🔮</div>
            <div class="empty-state-title">กำลังอัปเดตระบบ</div>
            <div class="empty-state-text">กรุณากลับมาใหม่ภายหลัง</div>
          </div>
        `}
      </div>
    </div>
    ${renderBottomNav('home')}
  `;

  // Bind card clicks
  tellers.forEach(ft => {
    const card = document.getElementById(`ft-card-${ft.id}`);
    if (card) {
      card.addEventListener('click', () => navigate(`/booking/${ft.id}`));
    }
  });
}

function renderTellerCard(ft) {
  const prices = ft.price ? Object.values(ft.price).filter(v => v > 0) : [];
  const minPrice = prices.length > 0 ? Math.min(...prices) : 0;

  return `
    <div class="card" id="ft-card-${ft.id}" style="cursor:pointer">
      <div class="card-header">
        <img class="card-avatar" src="${ft.pictureUrl || 'https://ui-avatars.com/api/?name= FT &background=9b59f0&color=fff&size=56'}" alt="${ft.name}"
             onerror="this.onerror=null; this.src='https://ui-avatars.com/api/?name= FT &background=9b59f0&color=fff&size=56'" />
        <div class="card-info">
          <h3>${ft.name}</h3>
          <p>${ft.specialty || ''}</p>
        </div>
      </div>
      ${ft.bio ? `<div class="card-body"><p>${ft.bio}</p></div>` : ''}
      <div class="card-footer">
        <div class="flex gap-sm" style="align-items:center;">
          <span class="text-gold fw-600">⭐ ${ft.rating || '5.0'}</span>
          <span class="text-xs text-muted">(${ft.reviewCount || 0} รีวิว)</span>
        </div>
        <span class="text-gold fw-600">${minPrice > 0 ? `เริ่มต้น ฿${minPrice.toLocaleString()}` : 'สอบถามราคา'}</span>
      </div>
    </div>
  `;
}
